import RecipePanel from "./RecipePanel"
export default RecipePanel
